export default {
  title: 'Kerusakan Dan Selisih',
  new: 'Baru',
  inProcess: 'Dalam Proses',
  resolve: 'Selesaikan',
  resolved: 'Selesai',
  process: 'Proses',
  damagedAndMissingList: 'Daftar pengiriman rusak dan selisih',
  searchText: 'Cari Nomor Pesanan',
  confirmProcess: 'Apakah anda yakin ingin memproses pengiriman ini?',
  confirmResolve: 'Apakah Anda yakin ingin menyelesaikan pengiriman ini?',
  noteInputLabel: 'Catatan:',
  noteInputValidationMsg: 'Catatan penyelesaian diperlukan',
  damagedAndMissingDetail: 'Detil Kerusakan/Selisih',
  documentation: 'Dokumentasi',
  noPhotos: 'tidak ada foto',
}
